import { Link } from 'react-router-dom';
import styles from './SiteHeader.module.css';

type NavItem = {
  readonly label: string;
  /** Internal route. When omitted, the item renders as an external/placeholder anchor. */
  readonly to?: string;
  /** External URL (e.g. mailto:). Used when `to` is omitted. */
  readonly href?: string;
};

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'サービス紹介', to: '/services' },
  { label: '会社概要', to: '/about' },
  { label: 'お問い合わせ', href: 'mailto:lisong@cji.jp' },
];

type SiteHeaderProps = {
  /** `overlay` floats transparently over a hero; `solid` sits in normal flow. */
  readonly variant?: 'overlay' | 'solid';
  /** `dark` = dark text (light background); `light` = white text (dark hero). */
  readonly tone?: 'dark' | 'light';
};

export const SiteHeader = ({
  variant = 'solid',
  tone = 'dark',
}: SiteHeaderProps): JSX.Element => {
  const className = [
    styles.header,
    variant === 'overlay' ? styles.overlay : '',
    tone === 'light' ? styles.light : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={className}>
      <Link to="/" className={styles.brand}>
        C.J INVESTMENT CO.,LTD
      </Link>
      <nav className={styles.nav}>
        {NAV_ITEMS.map((item) =>
          item.to ? (
            <Link key={item.label} to={item.to} className={styles.navLink}>
              {item.label}
            </Link>
          ) : (
            <a
              key={item.label}
              href={item.href ?? '#'}
              className={styles.navLink}
            >
              {item.label}
            </a>
          ),
        )}
      </nav>
    </header>
  );
};
